import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COLLECTIONS } from "../../data";

const ease = [0.22, 1, 0.36, 1];

const Card = ({ item, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay: (i % 3) * 0.08, ease }}
    className={`group relative ${item.span}`}
    data-testid={`collection-card-${i}`}
  >
    <div className={`relative overflow-hidden ${item.ratio} bg-stone border border-line`}>
      <img
        src={item.img}
        alt={item.name}
        loading="lazy"
        className={`img-zoom w-full h-full object-cover ${item.pos || "object-center"}`}
      />
      <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/10 transition-colors duration-500" />
    </div>
    <div className="flex items-baseline justify-between mt-3">
      <span className="text-[10px] uppercase tracking-[0.3em] text-ink/50">{item.line}</span>
      <span className="text-[10px] uppercase tracking-[0.3em] text-ink/30">{String(i + 1).padStart(2, "0")}</span>
    </div>
  </motion.div>
);

export const Collections = ({ preview = false, hideHeading = false }) => {
  const items = preview ? COLLECTIONS.slice(0, 6) : COLLECTIONS;
  return (
    <section id="collections" className="pb-24 md:pb-40 pt-4" data-testid="collections-section">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        {!hideHeading && (
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-24 pt-20 md:pt-36">
            <div>
              <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">The Collection</p>
              <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight max-w-2xl">
                Gowns for the <span className="italic">once</span> in a lifetime
              </h2>
            </div>
            <p className="max-w-sm text-ink/60 font-light md:text-right">
              {preview
                ? "A glimpse of the atelier. Every piece is made to order and shaped entirely to you."
                : "Each silhouette is designed, cut and sewn by Nancy — available to commission and shaped entirely to you."}
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {items.map((item, i) => (
            <Card key={item.name} item={item} i={i} />
          ))}
        </div>

        {preview && (
          <div className="mt-16 flex justify-center">
            <Link
              to="/collections"
              data-testid="view-all-gowns"
              className="btn-fill group inline-flex items-center gap-3 border border-ink px-10 py-4 text-xs uppercase tracking-[0.25em] font-medium hover:text-ivory transition-colors duration-500"
            >
              View all gowns
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};
